import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../../utils/createNotification';
import { TransactionDocuments } from '../../../../models/TransactionDocuments/transaction-documents.model';

export interface SaveRequiredDocumentTypesRequest {
    engagementId: number;
    documentTypes: string[];
}

export const SaveRequiredDocumentTypes = createAsyncThunk(
    'transactionDocuments/saveRequiredDocumentTypes',
    async (params: SaveRequiredDocumentTypesRequest, dispatch: any) => {
        const axios = dispatch.getState().core.axios;

        try {
            const response = await axios.put(
                `/api/Marketplace/Engagements/${params.engagementId}/TransactionDocuments/RequiredDocumentTypes`,
                { documentTypes: params.documentTypes }
            );

            if (response.status !== 200) {
                throw new Error('Failed to save the document types');
            }

            return response.data as TransactionDocuments;
        } catch (error) {
            createNotification('Could not save the document types.', 'error');
            throw error;
        }
    }
);
